export default __webpack_public_path__ + "static/media/leftLayer.effa541f.svg";